module.exports = __webpack_public_path__ + "img/clouds.a4f11db8.svg";